export default "__VITE_PUBLIC_ASSET__0cc380f4__"